<div class="datetime-picker">
  <p-calendar
    [(ngModel)]="date"
    dateFormat="D d MM"
    [minDate]="minDate"
    [maxDate]="maxDate"
    styleClass="datepicker"
    appendTo="body"
    [disabled]="disabled"
    [inline]="inline"
  >
  </p-calendar>

  <p-dropdown
    [options]="times"
    [(ngModel)]="time"
    styleClass="timepicker"
    appendTo="body"
    [autoWidth]="false"
    [hidden]="hidden"
    [disabled]="disabled"
  ></p-dropdown>
</div>
